export default __webpack_public_path__ + "static/media/slide3.03542e45.jpg";